import { createFileRoute } from '@tanstack/react-router';
import {
  SpaceMembersSection,
  SpaceOverviewSection,
} from '@/components/spaces/admin/index';
import { GroupVisibilitySection } from '@/components/group/admin/GroupVisibilitySection';
import { GroupArchiveSection } from '@/components/group/admin/GroupArchiveSection';
import { GroupBroadcastsSection } from '@/components/group/admin/GroupBroadcastsSection';
import { createGroupAdminRoute } from '@/lib/route-factories/group-admin-route';

export const Route = createFileRoute('/_authed/groups/$id/admin/')(
  createGroupAdminRoute({
    kind: 'space',
    fromId: '/_authed/groups/$id/admin/',
    renderSection: ({ id, section, broadcastStatus, broadcastCursor, session }) => {
      switch (section) {
        case 'overview':
          return <SpaceOverviewSection id={id} />;
        case 'visibility':
          return <GroupVisibilitySection id={id} kind="space" />;
        case 'members':
          return (
            <SpaceMembersSection id={id} viewerUserId={session.userId as string} />
          );
        case 'broadcasts':
          return (
            <GroupBroadcastsSection
              kind="space"
              groupId={id}
              listStatus={broadcastStatus}
              listCursor={broadcastCursor}
            />
          );
        case 'archive':
          return <GroupArchiveSection groupId={id} kind="space" />;
        // 'requests', 'circles', and 'join-questions' are not Space sections —
        // resolveGroupAdminSection won't return them — but the switch must
        // remain exhaustive.
        case 'requests':
        case 'circles':
        case 'join-questions':
          return null;
      }
    },
  }),
);
